import { z } from 'zod';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Core Schema
// ============================================================================
const licensureServiceConfigSchema = serviceConfigSchema.extend({
    licenseNumber: z.string(),
});
// ============================================================================
// DTO Schema
// ============================================================================
const licensureServiceConfigDtoSchema = serviceConfigSchema.extend({
    licenseNumber: z.string(),
});

export { licensureServiceConfigDtoSchema, licensureServiceConfigSchema };
//# sourceMappingURL=LicensureServiceConfig.js.map
